import { useGetMagazinesQuery } from '@/hooks/magazine/mobile/magazine.gql.impl';
import { GetMagazinesQuery } from '@/types/bff/gql-schema';
import { MagazineLineItemVo } from '@/types/magazine';
import dayjs from 'dayjs';

export const parseMagazineHomeNewest = (
  elements: Array<GetMagazinesQuery['magazineCursorPage']['elements'][0]>
): Array<MagazineLineItemVo> => {
  if (!elements) {
    return [];
  }

  return elements.map((magazine) => ({
    title: magazine.title,
    mobileTitle: magazine.mobileTitle,
    image: magazine.titleImageUrl,
    date: `${dayjs(magazine.createdAt).format('YYYY.MM.DD')}`,
    magazinePid: magazine.magazinePid,
    description: magazine.description,
    mobileDescription: magazine.mobileDescription,
  }));
};

const useGetFaqs = () => {
  const { data: faqs, isLoading: faqsIsLoading } = useGetMagazinesQuery(
    {
      magazineCursorPageRequestInput: {
        size: 5,
        contentType: 'FAQ',
      },
    },
    {
      select: (data) => parseMagazineHomeNewest(data.magazineCursorPage.elements),
    }
  );

  return {
    faqs: faqs ?? [],
    faqsIsLoading,
  };
};

export default useGetFaqs;
